import React, { useState, useEffect, Fragment, } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SlugComponentGuard, } from "./guards/slug";
import ErrorPage from '../../pages/error';
import {
  HomePage,
  ModulesPage,
  ProfilePage,
  VerificationPage,
  LoginPage,
  GroupsPage,
  DashboardPokjaPage,
  DashboardSurveyorInternalPage,
  DashboardSurveyorExternalPage,
  UsersPage,
  PokjaPage,
  MapingGroupsPage,
  AccreditationPage,
  ChapterAccreditationPage,
  DocumentSurveiPage,
  MasterStandardsPage,
  MasterChaptersPage,
  MasterElementsPage,
  MasterInstrumentsPage,
  ForumPage,
  PpsPage,
  PpsItemPage,
  PpsItemDokumenPage,
  ManagerFilesPage,
  RiskActivityTargetsPage,
  RiskRegisterPage,
  RiskHeatmapPage,
  RiskDivisionsPage,
} from '../../pages';
import { Navbar } from '../../components';
import { logo } from '../../assets';
import axios from '../../library/axios';
import { getSlug, } from "../../../src/config/routes/guards/slug";

const baseRoutes = [
  { path: "404", element: <ErrorPage /> },
  { path: "", element: <HomePage /> },
  { path: "accreditation", element: <AccreditationPage /> },
  { path: "profile", element: <ProfilePage /> },
  { path: "modules", element: <ModulesPage /> },
  { path: "groups", element: <GroupsPage /> },
  { path: "kelompok-kerja", element: <PokjaPage /> },
  { path: "dashboard-pokja", element: <DashboardPokjaPage /> },
  { path: "dashboard-internal", element: <DashboardSurveyorInternalPage /> },
  { path: "dashboard-surveyor-internal", element: <DashboardSurveyorInternalPage /> },
  { path: "dashboard-surveyor-external", element: <DashboardSurveyorExternalPage /> },
  { path: "users", element: <UsersPage /> },
  { path: "maping-groups", element: <MapingGroupsPage /> },
  { path: "chapter/:id/:idMasterAkreditasi", element: <ChapterAccreditationPage /> },
  { path: "documents", element: <DocumentSurveiPage /> },
  { path: "standards-accreditation", element: <MasterStandardsPage /> },
  { path: "chapters-accreditation", element: <MasterChaptersPage /> },
  { path: "elements-accreditation", element: <MasterElementsPage /> },
  { path: "variables-accreditation", element: <MasterInstrumentsPage /> },
  { path: "forum/:id/:idMasterAkreditasi", element: <ForumPage /> },
  { path: "pps/:id", element: <PpsPage /> },
  { path: "pps-item/:id", element: <PpsItemPage /> },
  { path: "pps-dokumen-item/:id/:idRekomendasi", element: <PpsItemDokumenPage /> },
  { path: "manager-file", element: <ManagerFilesPage /> },
  { path: "risk-activity-targets", element: <RiskActivityTargetsPage /> },
  { path: "risk-register/:id", element: <RiskRegisterPage /> },
  { path: "risk-heatmap", element: <RiskHeatmapPage /> },
  { path: "risk-divisions", element: <RiskDivisionsPage /> },
];

const RoutesConfig = () => {
  const [isValidate, setisValidate] = useState(false);

  const fetchData = async () => {
    try {
      const options = {
        url: `/profile/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      };
      const { data } = await axios(options);
      if (data.length > 0) {
        setisValidate(true);
      } else {
        setisValidate(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (! getSlug ()) return (<><ErrorPage /></>);

  if (isValidate === false && !localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)) {
    return (<>
      <SlugComponentGuard>
        <VerificationPage />
      </SlugComponentGuard>
    </>);
  }

  if (isValidate === true && !localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)) {
    return (<>
      <SlugComponentGuard>
        <LoginPage />
      </SlugComponentGuard>
    </>);
  }

  return (
    <>
      <SlugComponentGuard>
        <Router>
          {/*begin::Root*/}
          <div className="d-flex flex-column flex-root">
            {/*begin::Page*/}
            <div className="page d-flex flex-row flex-column-fluid">
              <Navbar />
              {/*begin::Wrapper*/}
              <div
                className="wrapper d-flex flex-column flex-row-fluid"
                id="kt_wrapper"
              >
                {/*begin::Header*/}
                <div
                  id="kt_header"
                  style={{}}
                  className="header align-items-stretch"
                >
                  {/*begin::Container*/}
                  <div className="container-fluid d-flex align-items-stretch justify-content-between">
                    {/*begin::Aside mobile toggle*/}

                    {/*end::Aside mobile toggle*/}

                    {/*begin::Mobile logo*/}
                    <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                      <span className="d-lg-none">
                        <img alt="Logo" src={logo} className="h-30px" />
                      </span>
                    </div>
                    {/*end::Mobile logo*/}
                  </div>
                  {/*end::Container*/}
                </div>
                {/*end::Header*/}
                <Routes>
                  {baseRoutes.map(({ path, element }) => (
                    <Fragment key={path}>
                      <Route
                        exact
                        path={`/hospitals/:slugId/${path}`}
                        element={
                          element
                        }
                      />
                    </Fragment>
                  ))}
                </Routes>
              </div>
              {/*end::Wrapper*/}
            </div>
            {/*end::Page*/}
          </div>
          {/*end::Root*/}
        </Router>
      </SlugComponentGuard>
    </>
  );
};

export default RoutesConfig;
